export const Default = {
    methods: {
        initialize: function () {
        },
        hideModal: function (data) {
            $('#' + data).modal('hide')
        },
        getBlock: function (data) {
            return this.Underscore.filter(this.blocks, function(item) {
                return item.widgets.title === data
            }).slice(0,1)
        },
        getBlocks: function (data) {
            return this.Underscore.filter(this.blocks, function(item) {
                return item.widgets.title === data
            })
        },
        getContent: function (page, data) {
            let content = this.Underscore.filter(page.content, function(item, key) {
                return key === data
            })
            return content.length ? content[0] : null
        },
        getSnippets: function (data) {
            let snippet = this.Underscore.filter(this.snippets, function(item) {
                return item.content.code_label === data
            })
            return snippet.length ? snippet[0].translations[this.locality].translation : data
        },
        getSettings: function (data) {
            let settings = this.Underscore.filter(this.settings, function(item) {
                return item.content.title === data
            })
            return settings.length ? settings[0].visibility : null
        },
        getHome: function (translatable, locality) {
            return translatable === true ? '/' + locality : '/'
        },
        getPath: function (data) {
            return '/' + data
        },
        getSlug: function (slug) {
            slug[slug.length -1] === '/' ? slug = slug.slice(0, -1) : null
            return slug
        },
        setCookies: function (data) {
            this.$store.dispatch('setCookies', data)
        },
        setOverflow: function () {
            $('body').removeClass('overflow-hidden')
        },
        setWindowTop: function () {
            $(window).scrollTop(0)
        },
        setNavigation: function (data) {
            this.$store.dispatch('setNavigation', data)
        },
        setMeta: async function () {
            let data = this.Underscore.first(this.getBlocks('Search Engine Optimisation'))
            switch (data) {
                case undefined:
                    this.meta.title = 'Božekovi gušti'
                    this.meta.author = 'Božekovi gušti'
                    this.meta.keywords = ''
                    this.meta.description = ''
                    this.meta.facebook_title = ''
                    this.meta.facebook_description = ''
                    this.meta.locality = this.locality
                    this.meta.image = 'https://via.placeholder.com/1366x768'
                    this.meta.url = window.location.href
                    break
                default:
                    this.meta.title = data.translations[this.locality].title
                    this.meta.author = data.translations[this.locality].title
                    this.meta.keywords = data.translations[this.locality].keywords
                    this.meta.description = data.translations[this.locality].description
                    this.meta.facebook_title = data.translations[this.locality].facebook_title
                    this.meta.facebook_description = data.translations[this.locality].facebook_description
                    this.meta.locality = this.locality
                    this.meta.url = window.location.href
                    let photo = this.Underscore.findWhere(this.$store.state.photos, { id: data.content.image_id })
                    switch (photo) {
                        case undefined:
                            this.meta.image = window.location.origin + '/' + 'app/images/static/placeholder.jpg'
                            break
                        default:
                            this.meta.image = window.location.origin + '/' + photo.path
                    }
            }
        },
        setLoading: function (data) {
            switch (data) {
                case true:
                    this.$store.dispatch('setLoading', data)
                    break
                case false:
                    setTimeout(() => {
                        this.$store.dispatch('setLoading', data)
                    }, 1000)
                    break
            }
        },
        setClient: async function (){
            this.$store.dispatch('setClient', await $.ajax({url: "https://geoip-db.com/jsonp", jsonpCallback: "callback", dataType: "jsonp"}))
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/Default.js